import React from 'react'
import MembershipTaskListForm from '../../features/MembershipTaskList/MembershipTaskListForm'

const MembershipTaskList = () => {
    return (
        <div>
            <MembershipTaskListForm />
        </div>
    )
}

export default MembershipTaskList
